module.exports = __webpack_public_path__ + "static/gallery7-efa83632065e67d05dd962fdffaef7df.jpg";